

import { trigger, state, style, transition, animate, } from '@angular/animations';
import { DecimalPipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Input,
  ViewChild,
  ViewContainerRef,
  EventEmitter,
  Output,
  SimpleChanges,
  Renderer2,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { Sort, MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { AlertService } from 'src/app/common/components/alert/alert.service';
import { ContactSalesComponent } from 'src/app/common/components/contact-sales/contact-sales.component';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { SharedService } from 'src/app/common/services/shared.service';
import { UserService } from 'src/app/common/services/user.service';
import { ReportMapService } from 'src/app/reports/services/report-map.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { CommonPropertyDetailConstant } from '../common-property-detail-page.constant';
import { CommonPropertyDetailPageService } from '../common-property-detail-page.service';
import { CommonPropertyDetailMenuEnum, DisableAnchor } from '../common-property-detail-page.enum';

@Component({
  selector: 'app-property-land-price-details-table',
  templateUrl: './property-land-price-details-table.component.html',
  styleUrls: ['./property-land-price-details-table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class PropertyLandPriceDetailsTableComponent {
  @Input() property_uid: string = '';
  @Output() pageEvent: EventEmitter<PageEvent> = new EventEmitter();
  @Output() sort: EventEmitter<Sort> = new EventEmitter();
  @ViewChild(MatPaginator) matPaginator: MatPaginator | any;
  @ViewChild(MatSort) matSort!: MatSort;
  @Output() isEmpatyCheck = new EventEmitter();
  overViewMenu = CommonPropertyDetailConstant.overViewMenu;
  tableColumns: any[] = CommonPropertyDetailConstant.landPricesColumns;
  tableData: any[] = [];
  showTooltip: boolean = false;
  showLoader: boolean = false;
  hidePagination: boolean = false;
  show_step_count: boolean = true;
  dataLength: number = 0;
  growthRate: any;
  showEstaterText: boolean = false;
  downloadLoading: boolean = false;
  allowExcelDownload: boolean = false;
  startIndex: number = 1;
  expandedElement: any = [];
  current_lang: string = 'en';
  CurrencyCode: string = '';
  languageSub$: Subscription = new Subscription();
  selectedIndex: string | null = null;
  colType: string = '';
  tenantLoading: boolean = false;
  expandbgColor = '';
  LockReport: boolean = true;
  totalPages: number | any;
  maxIndexValue: number = 20;
  endIndex: number = 20;
  goToPageNumber: number = 1;
  previousPageNbr: number = 1;
  limit: number = 20;
  offset: number = 0;
  sortOrder: string = '';
  allowDownload: boolean = false;
  currentReportData: any = null;
  BHRCHECK = environment.BHRCHECK;
  placeCode: any;
  reportId!: number;
  propertyCategory!: string;
  property_cat_subcat!: string;
  iswarehouseReport: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(
    private sharedService: SharedService,
    private translate: TranslateService,
    private mapService: ReportMapService,
    private reportService: ReportService,
    private propertyService: CommonPropertyDetailPageService,
    private alertService: AlertService,
    private _decimalPipe: DecimalPipe,
    private cdr: ChangeDetectorRef,
    private elementRef: ViewContainerRef,
    private ren: Renderer2,
    private matdailog: MatDialog,
    private userService: UserService,
    private activatedRoute: ActivatedRoute
  ) {
      this.languageSub$ = this.sharedService.language$.subscribe((lang) => {
      setTimeout(() => (this.current_lang = lang));
      this.CurrencyCode = this.translate.instant(
        this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode)
      );
      this.placeCode = this.sharedService.getStoreValue(
        GlobalContants.StoreKey.placeCode
      );
      // console.log(this.firstTime);
     
      if(this.property_uid){
       this.fetchTableData();
      };
      //  this.firstTime=false
    });

    this.propertyCategory = this.activatedRoute.snapshot.queryParams['property_category'];
    this.property_cat_subcat = this.activatedRoute.snapshot.queryParams['property_cat_subcat'];
    const category = this.propertyCategory || this.property_cat_subcat;
    this.iswarehouseReport = DisableAnchor.includes(category);
  }

  ngOnInit(): void {

  

    this.currentReportData = this.reportService.getCurrentReport();
    this.setDownloadAccess();
    this.CurrencyCode = this.translate.instant(
      this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode)
    );
    this.placeCode = this.sharedService.getStoreValue(
      GlobalContants.StoreKey.placeCode
    );
    this.reportId = this.activatedRoute.snapshot.queryParams['rid'];
    // this.fetchTableData();
  }

  ngOnChanges(changes: SimpleChanges): void {
     if (changes['property_uid']?.currentValue) {
      this.fetchTableData();
    }
    this.LockReport = this.reportService.getLockReport();
    this.setTableDataSource(this.tableData);
     this.startIndex = this.offset + 1;
     this.endIndex = Math.min(this.offset + this.limit, this.dataLength);
    if (changes['dataLength'] && changes['dataLength']?.currentValue) {
      this.goToPageNumber = 1;
      this.startIndex = 1;
     this.endIndex = Math.min(this.limit, changes['dataLength']?.currentValue);
    }
  }

  ngAfterViewInit(): void {
    if (this.matSort) {
      this.matSort.disableClear = true;
      this.matSort.sortChange
        .pipe(takeUntil(this.destroy$))
        .subscribe((sort: Sort) => this.onSortTable(sort));
    }

    if (this.matPaginator) {
      this.matPaginator.page
        .pipe(takeUntil(this.destroy$))
        .subscribe((page: PageEvent) => this.onPageChange(page));
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.languageSub$.unsubscribe();
  }

  fetchTableData(langChange: boolean = false) {
    this.showLoader = true;

    this.propertyService
      .getPropertyRental(this.limit, this.offset, this.sortOrder, this.property_uid, 'land_price')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.showLoader = false;
          if (res.status === 200) {
            const dataArr = Array.isArray(res.data) ? res.data : [res.data];
            dataArr.forEach((value: any) => {
              value['transaction_date'] = value.transaction_date
                ? moment.utc(value.transaction_date).local().format('DD MMM YYYY')
                : null;
              value['value'] = this.reportType(value);
              if (value?.source_type) {
                value['price_type'] = (value['price_type'] ?? '') + ` (${value.source_type})`;
              }
            });
            this.tableData = this.reportService.setTableDataSource(res.data);
            if(this.offset == 0){
              this.dataLength = res.count;
            }
            this.growthRate = res.growth_rate;
            this.setTableDataSource(this.tableData);
            this.isEmpatyCheck.emit(false);
            this.startIndex = this.offset + 1;
            this.endIndex = Math.min(this.offset + this.limit, this.dataLength); 
          } else {
            this.tableData = [];
            this.dataLength = 0;
            this.growthRate = 0;
            this.isEmpatyCheck.emit(true);
          }
        },
        error: () => {
          this.showLoader = false;
          this.tableData = [];
          this.dataLength = 0;
          this.growthRate = 0;
          this.isEmpatyCheck.emit(true);
        }
      });
  }


  reportType(value: any): string {
    let recordType = `<div class="reportType-value">${value.value ? this.reportService.numFormat(value.value) : ''}</div>`;
    if (value?.prop_type_govt && value?.prop_type_estater && value?.prop_type_govt !== value?.prop_type_estater) {
      recordType += `<div class="reportType-land"><del>${this.translate.instant(value?.prop_type_govt)}</del><span class='reportType'>*${this.translate.instant(value?.prop_type_estater)}</span></div>`;
    } else if (value?.prop_type_govt) {
      recordType += `<div class="reportType-land">${this.translate.instant(value?.prop_type_govt)}</div>`;
    } else if (value?.prop_type_estater) {
      recordType += `<div class="reportType-land">${this.translate.instant(value?.prop_type_estater)}</div>`;
    }
    return recordType;
  }
  isChildOpen(ele: any, pIndex: number) {
    const currentExpand = ele.expand;
    for (let j = 0; j < this.tableData.length; j++) {
      if (this.tableData[j].isParent) {
        this.tableData[j].expand = false;
      }
    }
    ele.expand = !currentExpand;
    this.onParentClick(pIndex);
    this.tableData = [...this.tableData];
  }

  onParentClick(parentIndex: number): void {
    if (this.tableData[parentIndex].isParent) {
      const isCurrentlyOpen = this.tableData[parentIndex].expand;
      for (let j = 0; j < this.tableData.length; j++) {
        if (!this.tableData[j].isParent) {
          this.tableData[j].isOpen = 1;
        }
      }
      let i = parentIndex + 1;
      while (i < this.tableData.length && !this.tableData[i].isParent) {
        this.tableData[i].isOpen = isCurrentlyOpen ? 2 : 1;
        i++;
      }
    }
  }
  showLayout(value: any, is_unit_layout?: boolean) {
    if (is_unit_layout) value['is_unit_layout'] = true;
    this.mapService.propertyinfotoggle.next(true);
    this.mapService.selected_propertydetails.next(value);
    this.reportService.showTenantMap$.next(value);
  }

  showTenant(value: any) {
    this.reportService.showUnitTenantMap$.next(value);
  }

  isCharNumber(value: any) {
    const toolTipValue =
      typeof value === 'string'
        ? value
        : this._decimalPipe.transform(value, '1.0-1');
    return `${toolTipValue} ${this.translate.instant(
      this.CurrencyCode
    )}/${this.translate.instant(
      GlobalContants.keySymbolContants.squareMeterUnit
    )}`;
  }

  setExpadndColor(index: number) {
    this.expandbgColor = '#EBF1FF';
  }

  setTableDataSource(data: any): void {
    this.LockReport = this.reportService.getLockReport();
    if (this.LockReport) {
      data = data.slice(0, 3);
      for (let i = 0; i < 3; i++) {
        let temp: any = {};
        this.tableColumns.map((e: any) => {
          temp[e.field] = e.convertNumber ? 1111111 : 'No data';
          temp['NODATA'] = true;
        });
        data.push(temp);
      }
      this.tableData = data;
    } else {
      this.tableData = data;
    }
    this.cdr.detectChanges();
    if (this.matPaginator) {
      this.totalPages = this.matPaginator.getNumberOfPages();
      this.addGoToPageInput();
    }
  }

  addGoToPageInput() {
    const actionContainer = this.elementRef.element.nativeElement.querySelector(
      'div.mat-mdc-paginator-range-actions'
    );
    const nextButtonDefault =
      this.elementRef.element.nativeElement.querySelector(
        'button.mat-mdc-paginator-navigation-next'
      );
    let bubbleContainerRef: any = this.ren.createElement('div') as HTMLElement;
    this.ren.addClass(bubbleContainerRef, 'g-bubble-container');
    this.ren.insertBefore(
      actionContainer,
      bubbleContainerRef,
      nextButtonDefault
    );
    bubbleContainerRef.appendChild(
      this.elementRef.element.nativeElement.querySelector('.go-to-page')
    );
  }

  openContactSales() {
    this.matdailog.open(ContactSalesComponent, {
      width: '600px',
      maxHeight: '95vh',
      panelClass: 'contact-form',
      data: { Type: 'contact_us' },
    });
  }

// Updated onPageChange method
onPageChange(event: PageEvent) {
  this.limit = event.pageSize;
  this.offset = event.pageIndex * event.pageSize;
  this.startIndex = this.offset + 1;
  this.endIndex = Math.min(this.offset + this.limit, this.dataLength);

  this.fetchTableData();
  this.goToPageNumber = event.pageIndex + 1;
}

  onGoToPage() {
    if (this.goToPageNumber > this.totalPages || this.goToPageNumber <= 0) {
      this.goToPageNumber = this.previousPageNbr;
      return;
    }
    this.previousPageNbr = this.goToPageNumber;
    this.matPaginator.pageIndex = this.goToPageNumber - 1;
    const event: PageEvent = {
      length: this.matPaginator.length,
      pageIndex: this.matPaginator.pageIndex,
      pageSize: this.matPaginator.pageSize,
    };
    this.goToPageNumber = (event.pageIndex || 0) + 1;
    this.onPageChange(event);
  }

  onSortTable(event: Sort) {
    let activeheader = event.active;
    this.sortOrder = event.direction
      ? JSON.stringify({ column: activeheader, order: event.direction }).replace(/[+]/g, '%2B')
      : '';

    this.offset = 0;
    this.goToPageNumber = 1;

    if (this.matPaginator) this.matPaginator.pageIndex = 0;

    this.fetchTableData();
  }


  resetPageIndex() {
    if (this.matPaginator) {
      this.matPaginator.pageIndex = 0;
    }
  }



  setDownloadAccess() {
    let subscription = this.reportService.userSubscription.find(
      (sub: any) => sub.report_id === this.currentReportData?.id
    );
    if (subscription) {
      this.allowDownload =
        subscription.allow_download && this.currentReportData?.is_download;
    }
  }
}